<template>
    <div class="import-photo-container">
        <div class="card-container">
            <div class="info-box info">
                <i class="el-icon-info"></i>
                <div>
                    <p><strong>说明：</strong></p>
                    <ul>
                        <li>点击下面的按钮可以进入“录取查询”页面</li>
                        <li>考生输入正确的姓名和身份证号后可以查询到录取信息</li>
                    </ul>
                </div>
            </div>
            <el-form :model="form" label-width="120px" class="import-form">
                <el-form-item>
                    <el-button type="primary" @click="handleSubmit">
                        点此进入录取查询地址
                    </el-button>
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>

<script>
import { TYBM_Env } from '../../env.js';
import { TYBM_Tools } from '../../tools.js';

export default {
    name: 'CxtzsEntry',
    inject: ['Loading', 'LoadingCompleted', 'getCurrentYear'],
    methods: {
        handleSubmit() {
            var that = this;

            const api_name = '/Notice/GetCxtzsUrl';
            // 拼接 year 参数以确保后端 Session 更新
            const year = this.$root.currentYear || ''; 
            var url = TYBM_Env.GetApiUrl(api_name) + (year ? '?year=' + year : '');
            TYBM_Tools.AxiosGetEx(that, api_name, url, { loading_msg: '正在加载数据' })
                .then(result => {
                    if (result.data && result.data.Url) {
                        // '_blank' 参数确保在浏览器新标签页/窗口中打开
                        window.open(result.data.Url, '_blank');
                    }
                }).catch(() => { });
        }
    },
    mounted() {
    }
};
</script>

<style scoped>
.import-photo-container {
    max-width: 900px;
}

.import-form {
    margin-top: 24px;
}

.info-box {
    padding: 16px;
    border-radius: 4px;
    margin-bottom: 24px;
    border-left: 4px solid;
    background-color: #e6f7ff;
    border-color: #1890ff;
    color: #0050b3;
    display: flex;
    gap: 12px;
}

.info-box i {
    font-size: 20px;
    margin-top: 2px;
}

.info-box ul {
    margin: 8px 0 0 20px;
    padding: 0;
}

.info-box li {
    margin: 4px 0;
}

.error-text {
    color: #f56c6c;
    font-size: 12px;
    line-height: 1;
    padding-top: 4px;
    display: block;
}

.result-container {
    margin-top: 24px;
}

.result-content {
    padding: 16px;
    background-color: #f5f7fa;
    border-radius: 4px;
    min-height: 100px;
}

/* 隐藏el-upload的原生input */
.import-form >>> .el-upload {
    display: inline-block;
}

.import-form >>> .el-upload input[type="file"] {
    display: none !important;
}
</style>

